import { createSlice } from '@reduxjs/toolkit'

import { getEventsCount } from './thunk'

const initialState = {
  events: 0,
  isEventsLoading: false,
  isEventsError: false
}

const header = createSlice({
  name: 'header',
  initialState,
  extraReducers: {
    [getEventsCount.pending]: (state) => {
      state.isEventsError = false
      state.isEventsLoading = true
    },
    [getEventsCount.fulfilled]: (state, action) => {
      state.isEventsError = false
      state.isEventsLoading = false
      state.events = action.payload
    },
    [getEventsCount.rejected]: (state) => {
      state.isEventsError = true
      state.isEventsLoading = false
    }
  }
})

const { reducer } = header

export default reducer
